import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Thin top-of-region bar for sustained / global conditions where a
 * toast is wrong (too transient) and a modal is wrong (too intrusive).
 * Typical uses: "We're having trouble connecting — retrying…",
 * scheduled maintenance notice, deprecated feature warnings.
 *
 * Severity controls the colour; `dismissible` adds a close button that
 * emits (dismissed) — the parent owns the shown/hidden state.
 */
@Component({
  selector: 'lib-page-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './page-banner.html',
  styleUrls: ['./page-banner.scss'],
})
export class PageBannerComponent {
  readonly severity = input<'info' | 'warning' | 'error'>('info');
  readonly message = input.required<string>();
  readonly dismissible = input<boolean>(false);
  /**
   * Optional action button rendered to the right of the message
   * (e.g. "Retry"). When provided, clicking it emits (action) — the
   * caller decides whether to also clear the banner.
   */
  readonly actionLabel = input<string | null>(null);

  @Output() readonly dismissed = new EventEmitter<void>();
  @Output() readonly action = new EventEmitter<void>();
}
